/**
 * dateUtils.js
 * Pure date/time helpers with no React or app dependencies.
 * Safe to call at module level — never recreated on render.
 */

export const formatDateYMD = (date) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatTimeHM = (date) => {
  if (!date) return "";
  const pad = (val) => String(val).padStart(2, "0");
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const toTimeInput = (date) => {
  if (!date) return "";
  const pad = (val) => String(val).padStart(2, "0");
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const toLocalDateTimeString = (date) => {
  if (!date) return null;
  const pad = (val) => String(val).padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
};

export const buildLocalDateTime = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return null;
  const [year, month, day] = dateStr.split("-").map(Number);
  const [hour, minute] = timeStr.split(":").map(Number);
  if ([year, month, day, hour, minute].some(Number.isNaN)) return null;
  return new Date(year, month - 1, day, hour, minute, 0);
};

export const getTodayFormatted = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getTimezoneAbbreviation = () => {
  return new Date()
    .toLocaleTimeString("en-US", { timeZoneName: "short" })
    .split(" ")[2];
};

/** Returns the current HH:MM string — use once on mount for FullCalendar scrollTime. */
export const getCalendarScrollTime = () => new Date().toTimeString().slice(0, 5);

/** Combines a YYYY-MM-DD date string and HH:MM time string into an ISO local datetime. */
export const toIsoLocal = (d, t) => `${d}T${t.length === 5 ? `${t}:00` : t}`;